export default __webpack_public_path__ + "static/Number-Picker-Wheel-0f6c86273c4d2e6a003c03f529021327.png";